import CheckboxMenuItem from '@components/v2/ui/Menu/CheckboxMenuItem';
import MenuItem from '@components/v2/ui/Menu/MenuItem';
import { ReactNode } from 'react';
import { RenderSelectOptionsParams, SelectOption, SelectOptionValue } from './select.types';

const toSelectedValues = (value: unknown): string[] =>
  Array.isArray(value) ? value.map(String) : [];

export const findOptionLabel = (options: SelectOption[], value: SelectOptionValue): ReactNode =>
  options.find((option) => String(option.value) === String(value))?.label;

export const renderSelectOptions = ({ options, multiple, value }: RenderSelectOptionsParams) => {
  if (!multiple) {
    return options.map((option) => (
      <MenuItem key={option.value} value={option.value} disabled={option.disabled}>
        {option.label}
      </MenuItem>
    ));
  }

  const selectedValues = toSelectedValues(value);

  return options.map((option) => (
    <CheckboxMenuItem
      key={option.value}
      value={option.value}
      disabled={option.disabled}
      selected={selectedValues.includes(String(option.value))}
    >
      {option.label}
    </CheckboxMenuItem>
  ));
};
